import ResultsSlice from "../../valueObjects/ResultsSlice.js";

/**
 * Checks whether scope of ResultsSlice is for batter, pitcher, handedness but without pitch type
 * @param {ResultsSlice} slice 
 * @returns bool
 */
const resultsSliceBeforePitchType = function(slice) {
    return !!(slice instanceof ResultsSlice
        && slice.scope.sessionId
        // && slice.scope.opponentId // it is commented as sometimes we could have no pitcher/batter here
        && !slice.scope.pitchType
        && slice.scope.tagId
        // && slice.scope.opponentTeamId
        && slice.scope.teamId
        // && slice.scope.opponentHandedness
        && slice.scope.handedness
    );
};

export default resultsSliceBeforePitchType;